import { render, staticRenderFns } from "./userCallList.vue?vue&type=template&id=3b8c7576&scoped=true&"
import script from "./userCallList.vue?vue&type=script&lang=js&"
export * from "./userCallList.vue?vue&type=script&lang=js&"
import style0 from "./userCallList.vue?vue&type=style&index=0&id=3b8c7576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c7576",
  null
  
)

export default component.exports